module.exports = __webpack_public_path__ + "static/media/service-seguridad.ba8cc5e5.png";